/// <reference types="vite-plugin-svgr/client" />
import React from "react";
import { useTranslation } from "react-i18next";
import { StyledPageWrapper, Title } from "@monorepo/components";
import { APPLE_STORE_APP_LINK, GOOGLE_PLAY_APP_LINK, HUAWEY_APP_GALLERY_APP_LINK } from "@monorepo/constants";
import theme from "@monorepo/styles/theme";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import FishermanBlob from "assets/blobs/FishermanBlob";
import AppleStore from "assets/img/appleStore.svg?react";
import GooglePlay from "assets/img/google.svg?react";
import HuaweyStore from "assets/img/huawey.svg?react";

import { PageWrapper, ServicesList } from "components/Services/ServicesPage";

const StoreWrapper = styled(Box)(() => ({
  display: "flex",
  justifyContent: "stretch",
  alignItems: "stretch",
  width: "160px",
  [theme.breakpoints.up("xl")]: {
    width: "200px",
    height: "50px",
  },
  "> svg": {
    width: "160px",
    height: "50px",
  },
}));

const FishermanTicketService: React.FC = () => {
  const { t } = useTranslation();
  return (
    <StyledPageWrapper>
      <PageWrapper>
        <Title noMaxWidth>{t("services.fishing_title")}</Title>
        <FishermanBlob />
        <Typography textAlign="justify" component="p">
          {t("fisherman_ticket.first_p")}
        </Typography>
        <Typography component="h2" sx={{ justifySelf: "flex-start" }} fontWeight="bold">
          {t("fisherman_ticket.first_ul_title")}
        </Typography>
        <ServicesList>
          <Typography component="li">{t("fisherman_ticket.first_ul_first_li")}</Typography>
        </ServicesList>

        <Typography textAlign="justify" component="h2" sx={{ justifySelf: "flex-start" }} fontWeight="bold">
          {t("fisherman_ticket.second_ul_title")}
        </Typography>
        <ServicesList>
          <Typography component="li">{t("fisherman_ticket.second_ul_first_li")}</Typography>
          <Typography component="li">{t("fisherman_ticket.second_ul_second_li")}</Typography>
          <Typography component="li">{t("fisherman_ticket.second_ul_third_li")}</Typography>
        </ServicesList>
        <Box
          sx={{
            rowGap: {
              xs: theme.spacing(2),
            },
            mt: theme.spacing(2),
            mb: theme.spacing(5),
            width: "100%",
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <a href={GOOGLE_PLAY_APP_LINK} target="_blank" rel="noreferrer">
            <StoreWrapper>
              <GooglePlay />
            </StoreWrapper>
          </a>
          <a href={APPLE_STORE_APP_LINK} target="_blank" rel="noreferrer">
            <StoreWrapper sx={{ marginX: theme.spacing(1) }}>
              <AppleStore />
            </StoreWrapper>
          </a>
          <a href={HUAWEY_APP_GALLERY_APP_LINK} target="_blank" rel="noreferrer">
            <StoreWrapper>
              <HuaweyStore />
            </StoreWrapper>
          </a>
        </Box>
      </PageWrapper>
    </StyledPageWrapper>
  );
};

export default FishermanTicketService;
